import { cn } from '@/lib/cn';

interface SkeletonProps {
  variant?: 'line' | 'card';
  className?: string;
}

/** Placeholder cinza com pulse enquanto carrega. */
export function Skeleton({ variant = 'line', className }: SkeletonProps) {
  return (
    <div
      aria-hidden
      className={cn(
        'animate-pulse bg-border/60',
        variant === 'line' ? 'h-4 rounded' : 'h-32 rounded-lg',
        className,
      )}
    />
  );
}
